<template lang="pug">
  el-menu-item(
    index='/cards'
  )
    .img-wrapper
      img(src="@src/assets/sidebar/transactions.svg")
    router-link.sub-menu-link(to="/cards")
      span  {{ $t('sidebar.cards') }}
</template>

<script>
import { general } from "@src/services/dynamicViews/general";
import { dynamicViewsConstants } from "@src/constants";
import { mapState } from "vuex";


export default {
  name: "CardsItem",
  mixins: [general],

  computed: {
    ...mapState("auth", ["user"]),
  },

  data() {
    return {
      dynamicViewsConstants
    }
  }
}
</script>
